export enum TourStatus {
  PENDING = 'Pending',
  ACTIVE = 'Active',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  SCHEDULED = 'scheduled',
  RESCHEDULED = 'rescheduled',
  PRE_BOOK = 'pre_book',
}

export enum TourActionType {
  CREATED = 'created',
  UPDATED = 'updated',
  CANCELLED = 'cancelled',
  RESCHEDULED = 'rescheduled',
}

export enum TourChannel {
  CALENDLY = 'Calendly',
  SMS = 'SMS',
  PORTAL = 'Portal',
  CHATBOT = 'Chatbot',
  LINK = 'Link',
}